import React from "react";

interface ChatMessageProps {
  content: string;
  isUserMessage: boolean;
  timestamp: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  content,
  isUserMessage,
  timestamp,
}) => {
  // Format timestamp
  const formatTime = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div
      className={`flex ${isUserMessage ? "justify-end" : "justify-start"} mb-4`}
    >
      <div
        className={`max-w-3/4 px-4 py-2 rounded-lg ${
          isUserMessage
            ? "bg-blue-500 text-white rounded-br-none"
            : "bg-gray-200 text-gray-800 rounded-bl-none"
        }`}
      >
        <div className="text-sm whitespace-pre-wrap break-words">{content}</div>
        <div
          className={`text-xs mt-1 ${
            isUserMessage ? "text-blue-100" : "text-gray-500"
          }`}
        >
          {formatTime(timestamp)}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
